<template>
  <BaseChoice
    title="関連付ける教場を選択してください"
    resourceType="school"
    :fields="fields"
    :items="school.schools"
    :totalItems="totalSchools"
    :isFetching="isFetching"
  />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseChoice from '@/views/choices/Base.vue';

export default {
  data() {
    return {
      isFetching: false,
    };
  },
  components: {
    BaseChoice,
  },
  mounted() {
    let filterBy = {};

    if (this.prevFormData.corporation) {
      filterBy.corporationId = this.prevFormData.corporation.id;
    }

    if (this.prevFormData.brand) {
      filterBy.brandId = this.prevFormData.brand.id;
    }

    this.$logger.debug('Start fetching School for Choices');
    this.clearSchools();
    this.isFetching = true;
    this.fetchSchools({ data: { filterBy } }).then(() => {
      this.isFetching = false;
      this.$logger.debug('Done fetching School for Choices');
    });
  },
  computed: {
    fields() {
      return [
        {
          key: 'uid',
          label: '教場ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '教場名',
          sortable: true,
          thAttr: { width: 300 },
        },
        {
          key: 'choiceResource',
          label: '選択',
          sortable: false,
          thAttr: { width: 60 },
        },
      ];
    },
    ...mapState(['school']),
    ...mapGetters('school', ['totalSchools']),
    ...mapState('form', ['prevFormData']),
  },
  methods: {
    ...mapActions('school', ['fetchSchools', 'clearSchools']),
  },
};
</script>
